module.exports = __webpack_public_path__ + "img/home_menu_2_selected.fb455547.png";